import { Component, OnDestroy, OnInit } from '@angular/core';
import { NodeService } from 'src/app/shared/services/node.services';
import { Subscription } from 'rxjs';
import { HelpersService } from 'src/app/shared/services/helpers.service';

@Component({
  selector: 'app-sitemap',
  templateUrl: './sitemap.component.html',
  styleUrls: ['./sitemap.component.scss']
})
export class SitemapComponent implements OnInit, OnDestroy {

  public mainMenu: any = [];
  public onChangeHeader$: Subscription = new Subscription();

  constructor(
    private nodeService: NodeService,
    private helpersService: HelpersService
  ) {
  }

  ngOnInit(): void {
    this.helpersService.nodeType = "pagina";
    if (this.nodeService.header) {
      this.mainMenu = this.nodeService.header.field_main_menu;
    }
    this.onChangeHeader$ = this.nodeService.onChangeHeader.subscribe(header => {
      this.mainMenu = header.field_main_menu;
    });
  }

  ngOnDestroy(): void {
    if (this.onChangeHeader$ instanceof Subscription) {
      this.onChangeHeader$.unsubscribe();
    }
  }

}
